import { useTranslation } from "react-i18next";
import Popup from "../../Atoms/Popup";
import H2 from "../../Atoms/H2";
import { Link } from "react-router-dom";

const PopupGoToSDE24 = (props) => {
    const { i18n } = useTranslation('common');
    return (
        <Popup close={props.close}>
            <H2>{i18n.language === "fr" ? "Rejoindre le SPEED DATING Espace & Métiers d'Art" : "Join the SPEED DATING Espace & Métiers d'Art"}</H2><br/><br/>
            <Link to="/evenements/learnmore?eid=65bbd3474931755ed1c4bbef">{i18n.language === "fr" ? "Cliquez ici pour vous inscrire" : "Click here to register"}</Link>
        </Popup>
    )
}

export default PopupGoToSDE24;